import { render, staticRenderFns } from "./license.vue?vue&type=template&id=3cc7488c&"
import script from "./license.vue?vue&type=script&lang=ts&"
export * from "./license.vue?vue&type=script&lang=ts&"
import style0 from "./license.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports